import { useCallback, useState } from 'react';
import {
  ButtonColor,
  ButtonVariant,
  Icon,
  Icons,
  SimLocationModal,
  TextButton,
  TextInput,
} from '../../../../components';
import { PathFolder, useAppDispatch } from '../../../../hooks';
import { setFolderId } from '../../../../redux/reducers';

interface FolderLocationFieldProps {
  orgId: string;
  folderId?: string;
}

const FolderLocationField = ({ folderId, orgId }: FolderLocationFieldProps) => {
  const dispatch = useAppDispatch();

  const [folderPath, setFolderPath] = useState<PathFolder[]>([]);
  const [isSimLocationModalOpen, setIsSimLocationModalOpen] = useState(false);

  const folderPathLabel = folderPath
    .map(({ name }, index) => `${name}${index === folderPath.length - 1 ? '' : ' > '}`)
    .join('');

  const onSave = useCallback(
    (newFolderId: string) => {
      dispatch(setFolderId(newFolderId));
      setIsSimLocationModalOpen(false);
    },
    [dispatch]
  );

  return (
    <>
      {folderId && (
        <TextInput
          onClick={() => setIsSimLocationModalOpen(true)}
          endElement={<Icons className="cursor-pointer" icon={Icon.FOLDER} />}
          value={folderPathLabel}
        />
      )}
      {!folderId && (
        <TextButton
          text="Select location"
          variant={ButtonVariant.SOFT}
          color={ButtonColor.NEUTRAL}
          onClick={() => setIsSimLocationModalOpen(true)}
        />
      )}
      <SimLocationModal
        currFolderId={folderId}
        isOpen={isSimLocationModalOpen}
        orgId={orgId}
        submitText="Save"
        title="Simulation location"
        closeModal={() => setIsSimLocationModalOpen(false)}
        onSubmit={onSave}
        setFolderPath={setFolderPath}
      />
    </>
  );
};

export default FolderLocationField;
